// @ts-check
import { onMounted, onBeforeUnmount } from 'vue'

/**
 * @param {() => Element | null | undefined} targetGetter
 * @param {() => void} cb
 */
export function useClickOutside(targetGetter, cb) {
  /**
   * @param {MouseEvent} e
   */
  function onDocClick(e) {
    const el = targetGetter()
    if (!el) return
    if (e.target instanceof Node && !el.contains(e.target)) cb()
  }

  onMounted(() => document.addEventListener('mousedown', onDocClick))
  onBeforeUnmount(() => document.removeEventListener('mousedown', onDocClick))
}













